<template>
  <div class="navcontent">
    <!-- <div
      :class="navShow ? 'open' : 'close'"
      style="align-self:center"
      ref="open"
      @click="spread"
    >
      <img class="spread" src="~images/dic.png" />
    </div>
    <transition name="el-zoom-in-center">
      <div class="navCase" v-show="navShow">
        <slot name="nav"></slot>
      </div>
    </transition> -->
    <slot name="nav"></slot>
    <div class="left-bar">
      <slot name="leftBar"></slot>
    </div>
    <div class="right-nav-bar">
      <slot name="rightNavBar"></slot>
    </div>
    <slot name="rightBar"></slot>
  </div>
</template>

<script>
export default {
  name: "NavBar",
  data() {
    return {
      navShow: true
    };
  },
  methods: {
    spread() {
      this.navShow = !this.navShow;
      if (this.navShow) {
        this.circle = true;
      } else {
        this.circle = false;
      }
    }
  }
};
</script>

<style lang="stylus" scoped>

@import '~styl/largeScreen/NavBar'
@import '~styl/smallScreen/NavBar'
.navcontent
    z-index 999
</style>
